import { type TableColumnsType, Tag, Typography } from 'antd'

import { FormattedDate } from '@/components/common/FormattedDate'

import { BalanceSummary } from './components/Balance'
import {
  MarkupCell,
  SalesCell,
  SpotCell,
} from './components/ProviderControlCells'
import type { ProviderControls } from './components/useProviderControls'
import { providerName } from './format'
import type { GpuProvider } from './hooks/useGpuAdmin'

export function providerColumns(
  controls?: ProviderControls,
): TableColumnsType<GpuProvider> {
  return [
    {
      title: 'Provider',
      dataIndex: 'key',
      render: (key: string) => (
        <Typography.Text strong>{providerName(key)}</Typography.Text>
      ),
    },
    {
      title: 'Sales',
      key: 'sales',
      render: (_, provider) => (
        <SalesCell provider={provider} controls={controls} />
      ),
    },
    {
      title: 'Spot',
      key: 'spot',
      render: (_, provider) => (
        <SpotCell provider={provider} controls={controls} />
      ),
    },
    {
      title: 'Markup',
      key: 'markup',
      render: (_, provider) => (
        <MarkupCell provider={provider} controls={controls} />
      ),
    },
    {
      title: 'Balance',
      dataIndex: 'balance',
      render: (balance: GpuProvider['balance']) => (
        <BalanceSummary balance={balance} />
      ),
    },
    { title: 'Live leases', dataIndex: 'live_leases', align: 'right' },
    { title: 'Saleable offers', dataIndex: 'saleable_offers', align: 'right' },
    {
      title: 'Catalog seen',
      dataIndex: 'catalog_last_seen_at',
      render: (date: string | null) => (
        <FormattedDate date={date} fmt="MMM d, HH:mm" />
      ),
    },
    {
      title: 'API module',
      dataIndex: 'api_module_loaded',
      render: (loaded: boolean) =>
        loaded ? <Tag>Loaded</Tag> : <Tag color="orange">Not loaded</Tag>,
    },
  ]
}
